import {
  ICancelSubscriptionPayload,
  IStartCheckoutSessionPayload,
  IUpdateSubscriptionPayload,
  SubscriptionsActionTypes,
  ICancelSubscriptionSuccessResponseBody,
  IUpdateSubscriptionSuccessResponseBody,
} from './types'

export const cancelSubscription = (payload: ICancelSubscriptionPayload) => ({
  type: SubscriptionsActionTypes.CANCEL_SUBSCRIPTION,
  payload,
})

export const cancelSubscriptionSuccess = (payload: ICancelSubscriptionSuccessResponseBody) => ({
  type: SubscriptionsActionTypes.CANCEL_SUBSCRIPTION_SUCCESS,
  payload
})

export const cancelSubscriptionFailure = () => ({
  type: SubscriptionsActionTypes.CANCEL_SUBSCRIPTION_FAILURE,
})

export const startCheckoutSession = (payload: IStartCheckoutSessionPayload) => ({
  type: SubscriptionsActionTypes.START_CHECKOUT_SESSION,
  payload
})

export const startCheckoutSessionFailure = () => ({
  type: SubscriptionsActionTypes.START_CHECKOUT_SESSION_FAILURE,
})

export const updateSubscription = (payload: IUpdateSubscriptionPayload) => ({
  type: SubscriptionsActionTypes.UPDATE_SUBSCRIPTION,
  payload,
})

export const updateSubscriptionSuccess = (payload: IUpdateSubscriptionSuccessResponseBody) => ({
  type: SubscriptionsActionTypes.UPDATE_SUBSCRIPTION_SUCCESS,
  payload,
})

export const updateSubscriptionFailure = () => ({
  type: SubscriptionsActionTypes.UPDATE_SUBSCRIPTION_FAILURE,
})
